import { render, staticRenderFns } from "./AutoCampaignWithTriggersCreate.vue?vue&type=template&id=5b95f83e&scoped=true&"
import script from "./AutoCampaignWithTriggersCreate.vue?vue&type=script&lang=js&"
export * from "./AutoCampaignWithTriggersCreate.vue?vue&type=script&lang=js&"
import style0 from "./AutoCampaignWithTriggersCreate.vue?vue&type=style&index=0&id=5b95f83e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b95f83e",
  null
  
)

export default component.exports